import { useCallback, useEffect, useState } from "react";
import { useAiEventStreamLifecycle } from "./useAiEventStream.ts";

type IndicatorType = "loading" | "alert" | null;

function useAiChatReasoningStatus(threadId: number | null, triggerStatusRead: number = 0) {
  const { hasStreamStarted, hasStreamEnded } = useAiEventStreamLifecycle(threadId);
  const [indicator, setIndicator] = useState<{ threadId: number | null; type: IndicatorType }>({ threadId, type: null });
  const setIndicatorType = useCallback((type: IndicatorType) => setIndicator({ threadId, type }), [threadId]);

  useEffect(() => {
    if (hasStreamEnded) {
      setIndicatorType("alert");
      return;
    }
    if (hasStreamStarted) {
      setIndicatorType("loading");
      return;
    }
    setIndicator((previous) =>
      previous.threadId !== threadId || previous.type === "loading" ? { threadId, type: null } : previous
    );
  }, [threadId, hasStreamStarted, hasStreamEnded, triggerStatusRead, setIndicatorType]);

  return {
    indicatorType: indicator.threadId === threadId ? indicator.type : null,
    setIndicatorType,
  };
}

export default useAiChatReasoningStatus;
